export default __webpack_public_path__ + "static/media/scooter-hidrogeno.969b94cc.jpg";